import { useState, useEffect } from "react";
function useDebounce(value, delay, callback, changed) {
    const [debounce, setDebounce] = useState(value);
    useEffect(()=>{
        const handler = setTimeout(()=>{
            setDebounce(value);
        }, delay);
        changed == null ? void 0 : changed(value);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value
    ]);
    useEffect(()=>{
        callback(debounce);
    }, [
        debounce
    ]);
    return debounce;
}
export { useDebounce };
